import { createSelector } from 'reselect';
import { RootState } from '../root.reducer';
import { SessionState } from './types';

const selectCache = (state: RootState) => state.session;

export const selectIsAuthenticated = createSelector(
  selectCache,
  (cache: SessionState) => cache.isAuthenticated
);

export const currentUser = createSelector(
  selectCache,
  (cache: SessionState) => cache.currentUser
);

export const selectSessionExipyIn = createSelector(
  selectCache,
  (cache: SessionState) => cache.sessionExpiryIn
);

export const selectScreenSize = createSelector(
  selectCache,
  (cache: SessionState) => cache.screenSize
);

export const selectInitial = createSelector(
  selectCache,
  (cache: SessionState) => cache.initial
);

export const selectMaintenance = createSelector(
  selectCache,
  (cache: SessionState) => cache.isMaintenance
);

export const selectUserProcess = createSelector(
  selectCache,
  (cache: SessionState) => cache.userProcess
);

export const selectBaseMap = createSelector(
  selectCache,
  (cache: SessionState) => cache.baseMap
);

export const selectCustomBaseMap = createSelector(
  selectCache,
  (cache: SessionState) => cache.customBaseMap
);

export const selectAlerts = createSelector(
  selectCache,
  (cache: SessionState) => cache.alerts
);

export const selectNotifications = createSelector(
  selectCache,
  (cache: SessionState) => cache.notifications
);

export const selectActivateIdle = createSelector(
  selectCache,
  (cache: SessionState) => cache.activateIdle
);

export const selectMailboxUnmatchedCount = createSelector(
  selectCache,
  (cache: SessionState) => cache.mailboxUnmatchedCount
);

export const selectIsSysAdminMode = createSelector(
  selectCache,
  (cache: SessionState) => cache.isSysAdminMode
);

export const selectIsShowHideTriggered = createSelector(
  selectCache,
  (cache: SessionState) => cache.isShowHideTriggered
);

export const selectShowOrganisationSuspendedModal = createSelector(
  selectCache,
  (cache: SessionState) => cache.showOrganisationSuspendedModal
);

export const selectorAlertNotificationShowHide = createSelector(
  selectCache,
  (cache: SessionState) =>
    cache.appConfig?.parsedValue?.isNotificationAlertEnabled
);

export const selectorAlertNotificationMessage = createSelector(
  selectCache,
  (cache: SessionState) => cache.appConfig?.parsedValue?.message
);
